import React from 'react';
import { ILinearGradient } from '@/version-types';
import { calculateGradientCoordinate } from '../file-kit';

export const LinearGradient: React.FC<{
    id: string;
    width: number;
    height: number;
    linearGradient: ILinearGradient;
}> = React.memo(({ id, width, height, linearGradient }) => {
    const { x0, y0, x1, y1 } = calculateGradientCoordinate(width, height, linearGradient.angle);
    return (
        <linearGradient id={id} gradientUnits="userSpaceOnUse" x1={x0} y1={y0} x2={x1} y2={y1}>
            {linearGradient.colors.map((item, index) => {
                return <stop key={index} offset={item.value} stopColor={item.color} />;
            })}
        </linearGradient>
    );
});
